import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//@ts-expect-error ts-migrate(2307) FIXME: Cannot find type decalarations for '@awesome.me/kit-89c13ac8b2/icons'.
import { byPrefixAndName } from "@awesome.me/kit-89c13ac8b2/icons";
import { twMerge } from "tailwind-merge";

type IconProps = {
  faIcon: { style: string; name: string };
  className?: string;
};
const Icon = ({ faIcon, className }: IconProps) => {
  if (!faIcon) return null;

  // faIcon is object with style and name key -> {style: "fas", name: "home"}

  const faStyle = faIcon["style"] || "far";
  const faName = faIcon["name"];

  // Check if faName is set
  if (!faName) return null;

  // Check if faStyle and faName are in the icons object
  if (!byPrefixAndName[faStyle] || !byPrefixAndName[faStyle][faName])
    throw new Error(`Icon not found: ${faStyle} ${faName}`);

  return (
    <div
      className={twMerge("flex items-center justify-center w-8 h-8", className)}
    >
      <FontAwesomeIcon
        className="!h-full !w-full"
        icon={byPrefixAndName[faStyle][faName]}
      />
    </div>
  );
};

const SuccessIcon = () => (
  <Icon
    faIcon={{ style: "fas", name: "check" }}
    className="text-green-500 w-5 h-5"
  />
);
const FailureIcon = () => (
  <Icon
    faIcon={{ style: "fal", name: "times" }}
    className="text-red-500 w-5 h-5"
  />
);

export { Icon, SuccessIcon, FailureIcon };
